import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Axios from "axios";

const Approvepost = () => {
    const search = useLocation().search;
    const ContentId = new URLSearchParams(search).get("ContentId");
    const [message, setMessage] = useState("Approving your post...");

    const APICall = async () => {
        if (!ContentId) {
            console.error("Invalid ContentId");
            setMessage("Invalid request. No content ID provided.");
            return;
        }

        try {
            const response = await Axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/approve-post`,
                { ContentId, Status: "APPROVED" },
                { headers: { "Content-Type": "application/json" } }
            );

            if (response.data.message === "Post approved successfully") {
                console.log("Post approved successfully!");
                setMessage("✅ Your post has been approved and will be posted on the scheduled date.");
            } else {
                console.error(response.data.message || "Failed to approve post");
                setMessage(`❌ ${response.data.message || response.data.error || "Failed to approve post"}`);
            }
        } catch (error) {
            console.error("Error:", error);
            const errorMessage = error.response?.data?.message || 
                                error.response?.data?.error || 
                                error.message || 
                                "An error occurred while approving your post.";
            setMessage(`❌ ${errorMessage}`);
        }
    };

    useEffect(() => {
        APICall();
    }, []);

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
            <div className="text-center">
                <h3>{message}</h3>
            </div>
        </div>
    );
};

export default Approvepost;
